<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="sectionHeader">
        <div class="header">
          <div class="title">
              <div class="label">
                  {{'BILLS.title' | translate}}
              </div>
              <div class="help">
                <!-- <app-help [helpData]="helpData" ></app-help> -->
              </div>
            </div>
        </div>
      </div>

      <div class="status">
          <div class="view">
              <div class="liveStatus">
                  <div class="title">
                      {{'BILLS.status' | translate}}
                  </div>
                  <div class="row">
                      <div class="card" [ngClass]="{'orange orange-selected': selectStatusArray.non_settled, 'orange': !selectStatusArray.non_settled}" (click)="selectStatus('NON-SETTLED','non_settled')">
                      <div class="label"  [ngClass]="{'selectedLabel': selectStatusArray.non_settled}">
                          {{'BILLS.pending_for_payment' | translate}}
                      </div>
                      <div class="content" [ngClass]="{'selectedContent': selectStatusArray.non_settled}">
                          <mat-spinner *ngIf="status_data.pending_for_payment.loader" [diameter]="20"></mat-spinner>
                          <span *ngIf="!status_data.pending_for_payment.loader">{{ status_data.pending_for_payment.value }}</span>
                      </div>
                      </div>
                      <div class="card" [ngClass]="{'green green-selected': selectStatusArray.settled, 'green': !selectStatusArray.settled}" (click)="selectStatus('SETTLED','settled')">
                      <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.settled}">
                          {{'BILLS.completely_received' | translate}}
                      </div>
                      <div class="content"  [ngClass]="{'selectedContent': selectStatusArray.settled}">
                          <mat-spinner *ngIf="status_data.completely_received.loader" [diameter]="20"></mat-spinner>
                          <span *ngIf="!status_data.completely_received.loader">{{ status_data.completely_received.value }}</span>
                          </div>
                      </div>
                      <div class="card" [ngClass]="{'blue blue-selected': selectStatusArray.par_settled, 'blue': !selectStatusArray.par_settled}" (click)="selectStatus('PAR-SETTLED','par_settled');">
                          <div class="label" [ngClass]="{'selectedLabel': selectStatusArray.par_settled}">
                              {{'BILLS.partially_received' | translate}}
                          </div>
                          <div class="content" [ngClass]="{'selectedContent': selectStatusArray.par_settled}">
                              <mat-spinner *ngIf="status_data.partially_received.loader" [diameter]="20"></mat-spinner>
                              <span *ngIf="!status_data.partially_received.loader">{{ status_data.partially_received.value }}</span>
                          </div>
                      </div>
                  </div>
              </div>
       </div>
      </div>
      <div class="filter">
        <div class="container">
        <div class="select-shipper">
            <div class="title">
                    {{'CREATE_BILLS.enterprise_unit_name' | translate}}
            </div>
            <mat-select class="inputSelect" [(ngModel)]="selectedShipper">
                <mat-option *ngFor="let shipper of shippersArray" [value]="shipper" (click)="selectShipper(shipper)">
                  {{shipper.parent_name}} <span *ngIf="shipper.name"> - {{shipper.name}}</span>
                </mat-option>
            </mat-select>
        </div>
        <div class="transit-type" >
          <div class="title">
              {{'CREATE_BILLS.transit_type' | translate}}
          </div>
          <mat-select class="inputSelect" [(ngModel)]="selectedTransitType">
              <mat-option *ngFor="let transit_type of transit_types" [value]="transit_type" (click)="selectTransitType(transit_type)">
                  {{transit_type.name}}
              </mat-option>
          </mat-select>
        </div>
        <div class="search">
            <!-- <div class="inputSearch">
                <input (keyup)="applyFilter($event.target.value)" placeholder=""  class="inputSelect">
            </div> -->
        </div>
        <div class="select-date">
            <div class="title">
                    {{'CREATE_BILLS.from' | translate}}    
            </div>
            <div >
                <input type="text" class="dateSelect" [matDatepicker]="from_date"  [(ngModel)]="date_filter.from_date" [max]="date_filter.max" (click)="from_date.open()"/>
                <mat-datepicker #from_date (closed)="setFromDateTime(date_filter)" [startAt]="date_filter.from_date"></mat-datepicker>
                <i class="material-icons calendar">date_range</i>
            </div>
        </div>

        <div class="select-date">
            <div class="title">
                    {{'CREATE_BILLS.to' | translate}}    
            </div>
            <div >
                <input type="text" class="dateSelect" [matDatepicker]="to_date" [(ngModel)]="date_filter.to_date" [min]="date_filter.min" (click)="to_date.open()"/>
                <i class="material-icons icon calendar">date_range</i>
                <mat-datepicker #to_date (closed)="setToDateTime(date_filter)" [startAt]="date_filter.to_date" ></mat-datepicker>
            </div>
        </div>
      </div>
      </div>
        <div class="table" >
              <table mat-table class="mat-elevation-z8" #table [dataSource]="billsList.filteredData" *ngIf="billsList && billsList.filteredData.length;else noBills ">
                      <ng-container matColumnDef="bill_no">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'BILLS.bill_no' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                               <a href="{{ element.pdf_link }}">{{element.bill_id}}</a>
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="shipper">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'BILLS.shipper' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">{{element.enterprise_name}}</td>
                      </ng-container>

                      <ng-container matColumnDef="due_date">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'BILLS.due_date' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{element.due_date}}
                          </td>
                      </ng-container>

                      <ng-container matColumnDef="received_on">
                          <th mat-header-cell *matHeaderCellDef>
                              {{'BILLS.received_on' | translate}}
                          </th>
                          <td mat-cell *matCellDef="let element">
                            {{ element.bill_date }}
                          </td>
                      </ng-container>
                      <ng-container matColumnDef="payment_status">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'BILLS.payment_status' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <div class="status">
                            <div [ngClass]="{'completely-received': element.status == 'SETTLED','pending':element.status == 'NON-SETTLED','partially-received':element.status == 'PAR-SETTLED'}"> 
                              {{ element.status }}
                            </div>
                            <!-- {{ element.payment_status }} -->
                          </div>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="total_amount">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'BILLS.total_amount' | translate}} ({{currencySymbol}})
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.amount}}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="received_amount">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'BILLS.received_amount' | translate}} ({{currencySymbol}})
                        </th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.received_amount }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>
                            <!-- <div class="input">
                                <input type="text" placeholder="Bill Cycle">
                            </div> -->
                            {{'BILLS.actions' | translate}}
                        </th>
                        <td mat-cell *matCellDef="let element" style="width: 60px;">
                          <mat-icon class="more-icon" style="cursor: pointer" [matMenuTriggerFor]="actions"
                            (click)="$event.stopPropagation()">
                            more_vert</mat-icon>
                          <mat-menu #actions="matMenu">
                              <button mat-menu-item (click)="openCreateCreditNoteModal(element)">{{'BILLS.create_credit_note' |
                                translate}}</button>
                              <button mat-menu-item (click)="openConsolidateInvoiceDialg(element)">{{'BILLS.editConsolidateInvoice' | translate}}</button>
                          </mat-menu>
                        </td>
                        <!-- <td  mat-cell *matCellDef="let element"> <a class="invoice_text" href="{{element.invoice_link}}">{{element.invoice_pdf}}</a></td> -->
                    </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayColumns;" ></tr> 
                  </table>
                  <mat-paginator [length]="(bills.length) ? totalBills : 0" [pageSizeOptions]="[5, 10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons
                      (page)="pageNavigate($event)" style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>
        </div>
        <ng-template #noBills>
          <div class="noBills">
                  {{'BILLS.no_bills_found' | translate}}
          </div>
        </ng-template>
    </div>
  </div>

  <ng-template #editConsolidateInvoice>
    <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="editConsolidateInvoiceRef.close();newInvoice=''">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    <div class="editConsolidateInvoice">
      <div class="dialog_header">
        <div class="dialog_title">{{'BILLS.existing_invoice' | translate}} {{existingInvoice}} </div>
      </div>
      <div class="dialog_body">
        <div class="item" style="padding-top: 44px">
          <div class="input did-floating-label-content">
            <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;"  [(ngModel)]="newInvoice"/>
            <label class="did-floating-label">{{'BILLS.custom_consolidate_invoice' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="dialog_footer">
        <div class="dialog_footer_btn" (click)="updateConsolidateInvoice()">{{'Submit'| translate}}</div>

        <div class="dialog_footer_btn_1" (click)="editConsolidateInvoiceRef.close();newInvoice='' " >{{'Cancel'| translate}}</div>
      </div>
    </div>
  </ng-template>

